<template>
	<div style="display:flex;flex-direction: column;height: 100%">
	  <div class="newLogin">
       <div class="login-top"></div>
        <div class="login-main animated fadeInRight">
          <img style="display: block;width: 100px;margin: 0 auto;" src="@/assets/img/logo2.png" alt="">
          <span class="title1">{{$t("logon.signIn")}}</span>
              <div class="login-box">
                  <div v-if="loginMethod =='pwd'" class="animated fadeIn" key="box1">
                    <code-login :loginMethod.sync="loginMethod"></code-login>
                  </div>
                  <div v-else key="box2" class="animated fadeIn">
                    <pwd-login :loginMethod.sync="loginMethod"></pwd-login>
                  </div>
              </div>
        </div>
	  </div>
    <div class="footer">
      <ul class="footerList clearfix">
        <li><a href="/hrcloud/index.action">{{$t("logon.home")}}</a></li>
        <li><a href="/hrcloud/service.action">{{$t("logon.customService")}}</a></li>
        <li><a href="/hrcloud/aboutUs.action">{{$t("logon.about")}}</a></li>
      </ul>
      <p>Copyright © https://www.ciicpt.com.cn, All Rights Reserved. </p>
    </div>
  </div>
</template>

<script>
import { setRem } from '@/util/commen.js'
import codeLogin from './codelogin'
import pwdLogin from './pwdlogin'

export default {
	name: 'codelogin',

	components: { codeLogin, pwdLogin },

	data() {
		return {
			loginMethod: 'code'
		}
	},

	created() {
		setRem()
	},
}
</script>

<style scoped="scoped">
	.login-top:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
		width: 100%;
		height: 261px;
		background: url(../../assets/img/loginBg1.png) no-repeat center 0;
		background-size: 14.87rem;
	}

	/*.login-top:after {*/
	/*	content: "";*/
	/*	position: absolute;*/
	/*	left: 0;*/
	/*	z-index: -1;*/
  /*  width: 100%;*/
  /*  background: url(../../assets/img/loginBg2.png) no-repeat center 0;*/
  /*  height: 357px*/

	/*}*/
	.footer {
     width: 110%;
    background-color: #333333;
    padding: .43rem 0;
    text-align: center;
    font-size: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
	}

	.newLogin {
		margin-top: .8rem;
		text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
	}

	.login-main {
    position: relative;
    flex: 1;
	}
  .login-main:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: -1;
    width: 100%;
    background: url(../../assets/img/loginBg2.png) no-repeat center 0;
    height: 357px

  }
	span.title1 {
		font-size: 20px;
		color: #000000;
		font-weight: bold;
		margin-top: 1.08rem;
		margin-bottom: .36rem;

	}

	.title1>span {
		position: relative;

	}

	.title1>span:before {
		content: "";
		position: absolute;
		bottom: -10px;
		left: 0;
		width: 100%;
		height: 4px;
		border-radius: 2px;
		background-color: #00A8FF;
	}

	.login-box {
		width: 360px;
		margin: 0 auto;
	}

	/* 	.title>span:before{
			    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background-color: #00A8FF;
		} */
	.login-main>>>.el-input__inner {
		border: 1px solid #a0dfff;
		height: 30px;
		line-height: 30px;
	}

	.login-main>>>.el-form-item {
		margin-bottom: .18rem;
	}

	.footerList {
		padding: 0;
		margin: 0 auto;
		display: inline-block;
		vertical-align: top;
		font-size: 0;
	}

	.footerList li {
		list-style: none;
		float: left;
		padding: 0 16px;
		position: relative;

	}

	.footerList li a {
		color: #cccccc;
		font-size: 16px;
		line-height: 28px;
	}

	.footerList li:first-child:before {
		width: 0;
		height: 0;
	}

	.footerList li:before {
		content: "";
		position: absolute;
		left: 0;
		top: 6px;
		width: 1px;
		height: 16px;
		background-color: #cccccc;
	}

	.footer p {
		color: #666666;
		font-size: 14px;
		line-height: 26px;
		text-align: center;
		margin-top: .10rem;
	}
</style>
<style>
  #app{
    overflow-y: scroll;
    margin-right: -7px;
  }
</style>
